(function () {
    'use strict';
    $(document).ready(function () {
        const $menuOverlay = $('.menu-overlay');

        // Menu toggle
        $(".menu-toggle").on('click', function () {
            $menuOverlay.fadeToggle();
            $menuOverlay.toggleClass('open');
            $(this).toggleClass("open");
        });
    });
}(jQuery));